import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Axios from "axios";
import {
    Box,
    Container,
    Paper,
    TextField,
    Button,
    Typography,
    InputAdornment,
    IconButton,
    Avatar,
} from "@mui/material";
import { AccountCircle, Lock, Visibility, VisibilityOff } from "@mui/icons-material";

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        try {
            // ลบ item ทั้งหมดใน localStorage
            localStorage.clear();
        } catch (error) {
            toast.error(error.message);
        }
    };

    const handleLogin = async (event) => {
        event.preventDefault();
        try {
            if (!username || !password) {
                toast.error("กรุณากรอกชื่อผู้ใช้และรหัสผ่าน");
                return;
            }

            const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/login`, {
                username,
                password,
            }, {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
            });

            const { status, message, token } = response.data;

            if (status === 'OK') {
                const authenResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/authen`, {}, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        key: process.env.REACT_APP_ANALYTICS_KEY,
                    }
                });

                const authenStatus = authenResponse.data.status;
                const authenData = authenResponse.data.decoded;
                const role = authenResponse.data.position;

                if (authenStatus === 'OK') {
                    const roleName = role?.PST_Name || ([1, 2].includes(Number(authenData.Emp_Role)) ? 'Admin' : '');
                    localStorage.setItem('token', token);
                    localStorage.setItem('emp_id', authenData.Emp_Id);
                    localStorage.setItem('name', authenData.Emp_Name);
                    localStorage.setItem('company', authenData.Comp_Id);
                    localStorage.setItem('role', roleName);
                    localStorage.setItem('role_code', authenData.Emp_Role);
                    try {
                        localStorage.setItem(
                            'org_access',
                            JSON.stringify(authenResponse.data.org_access || { scoped: false, legacy: true })
                        );
                    } catch {
                        localStorage.removeItem('org_access');
                    }
                    window.location.replace("/");
                } else {
                    localStorage.clear();
                    toast.error(message);
                }
            } else {
                localStorage.clear();
                toast.error(message);
            }
        } catch (error) {
            console.error('Error during login:', error);
            toast.error(error.message);
        }
    };

    return (
        <Box className="Login" sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 4,
        }}>
            <Container maxWidth="sm">
                <Paper
                    elevation={8}
                    sx={{
                        p: 6,
                        borderRadius: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: 4,
                    }}
                    component="form"
                    onSubmit={handleLogin}
                >
                    <Box textAlign="center" mb={3}>
                        <Avatar
                            src="/logo.png"
                            alt="Thunder Bee Logo"
                            sx={{ width: 80, height: 80, mx: 'auto', mb: 1 }}
                            variant="square"
                        />
                        <Typography variant="h5" fontWeight={700} sx={{ color: '#E13F57' }}>
                            Sign in to Thunder Bee
                        </Typography>
                    </Box>

                    <TextField
                        id="login_username"
                        label="Username"
                        placeholder="Username"
                        fullWidth
                        margin="normal"
                        size="medium"
                        variant="outlined"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountCircle />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        id="login_password"
                        label="Password"
                        placeholder="Password"
                        fullWidth
                        margin="normal"
                        size="medium"
                        variant="outlined"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword((v) => !v)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                        sx={{
                            mt: 4,
                            bgcolor: '#E13F57',
                            color: '#fff',
                            boxShadow: 2,
                            borderRadius: '2rem',
                            '&:hover': { bgcolor: '#C72C55' },
                        }}
                    >
                        Login
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
}

export default Login;